/**
 * Footer Component
 * Application footer with copyright and links
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const FooterContainer = styled(Box)({
  backgroundColor: '#FAFBFC',
  borderTop: '1px solid #E5E7EB',
  padding: '16px 0',
  marginTop: 'auto',
});

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer component="footer">
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {/* Left: Copyright — flex:1 + left-align keeps it pinned left */}
          <Typography variant="caption" sx={{ color: '#9CA3AF', flex: 1 }}>
            © {currentYear} Provana Inc. All rights reserved.
          </Typography>

          {/* Center: App name — always geometrically centered */}
          <Typography variant="caption" color="text.secondary">
            Work Allocation System
          </Typography>

          {/* Right: Version — flex:1 + right-align keeps it pinned right */}
          <Typography variant="caption" color="text.secondary" sx={{ flex: 1, textAlign: 'right' }}>
            Version 1.0.0
          </Typography>
        </Box>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
